module.exports = __webpack_public_path__ + "static/media/5.71d021c4.svg";